<template>
  <div class="border mc-vehicle-media__content-wrapper">
    <div
      v-if="!loadingLoadData && groupedMediaByDate.length === 0 && mediaList.length === 0"
      class="mc-vehicle-media__empty-state-wrapper"
    >
      <div class="text-center">
        <img src="@/assets/images/no-data-illustration.png" width="312" alt />
        <h3>{{ $t('media.emptyState.title') }}</h3>
        <p>{{ $t('media.emptyState.description') }}</p>
      </div>
    </div>
    <template v-else>
      <div
        v-for="(mediaDate, indexParent) in groupedMediaByDate"
        :key="indexParent"
        class="mc-vehicle-media__media-date-wrapper"
      >
        <div class="mc-vehicle-media__media-header-wrapper">
          <i
            v-show="!dateCollapsed.includes(mediaDate.formattedDate)"
            class="mc-icon icon-outline_chevron-up"
            @click="addCollapsed(mediaDate.formattedDate)"
          ></i>
          <i
            v-show="dateCollapsed.includes(mediaDate.formattedDate)"
            class="mc-icon icon-outline_chevron-down"
            @click="removeCollapsed(mediaDate.formattedDate)"
          ></i>
          <h4 class="mc-vehicle-media__media-header-date-label">
            {{ mediaDate.formattedDate }}
          </h4>
        </div>
        <b-collapse :visible="!dateCollapsed.includes(mediaDate.formattedDate)">
          <div class="mc-vehicle-media__media-list-wrapper">
            <template v-if="!groupingBasedOnDate">
              <MediaItem
                v-for="(media, indexChild) in mediaDate.media"
                :key="media.downloadId + '-' + indexChild"
                :mediaItem="media"
                :formattedDate="mediaDate.formattedDate"
                :indexMedia="indexChild"
                :address="mapAddress[media.vehicle.id + '_' + media.startTime]"
                @openModal="handleClickMediaItem(media)"
              />
            </template>
            <template v-else>
              <MediaItem
                v-for="(mediaGroup, indexChild) in mediaDate.mediaGrouped"
                :key="indexChild"
                :mediaGroup="mediaGroup"
                :formattedDate="mediaDate.formattedDate"
                :indexMedia="indexChild"
                :address="mapAddress[mediaGroup.vehicleId + '_' + mediaGroup.startTime]"
                @openModal="handleClickMediaItem(mediaGroup)"
              />
            </template>
          </div>
        </b-collapse>
      </div>
    </template>

    <b-row v-if="loadingLoadData" class="mc-vehicle-media__skeleton">
      <b-col v-for="n in [...Array(4).keys()]" :key="n" cols="3">
        <b-skeleton-img />
      </b-col>
      <b-col cols="12" class="mt-3">
        <b-skeleton />
      </b-col>
      <b-col cols="12" class="mt-2">
        <b-skeleton />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import MediaItem from './MediaItem.vue'
import { GET_MEDIA_LIST } from '../../../../services/api/media'
import { Helper } from '@/mixin/helper'
import { GetAddressData } from '@/services/api/map'
import moment from 'moment'
import { GET_RAW_LOCATION } from '@/services/api/fleet'
import { DEVICE_CODE_LIST } from '@/helpers/device-code'

moment.locale('id')

export default {
  components: {
    MediaItem,
  },
  mixins: [Helper],
  props: {
    activeFilters: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loadingLoadData: true,
      mediaList: [],
      paginationState: {
        page: 1,
        show: 20,
        total: 0,
      },
      dateCollapsed: [],
      loadingGrouping: false,
      mapAddress: {},
      allLocations: [],
      rawAlertsMediaDate: [],
      keyMediaAddressLocalStorage: 'media_address',
      search: '',
      scrollYPosition: null,
      hasReachLimitData: false,
      dateNow: moment().toISOString(),
      mapMedia: {},
      tempAlreadyTimeKeyMedia: {},
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),

    ...mapState('media', ['fieldsStatus', 'defaultCameraThumbnail', 'groupingBasedOnDate']),

    hasScopeNewModalMedia() {
      return this.hasAccess('b3t-trackvision-new-modal-media-alert:read')
    },

    groupedMediaByDate() {
      if (this.mediaList.length === 0) return []
      // Get device's timezone offset in minutes
      const deviceOffset = new Date().getTimezoneOffset()
      // Convert offset to milliseconds (negative because getTimezoneOffset() returns opposite of what we need)
      const deviceOffsetMs = -deviceOffset * 60 * 1000

      const grouped = {}

      this.mediaList.forEach((media) => {
        const dateKey = new Date(new Date(media.startTime).getTime() + deviceOffsetMs)
          .toISOString()
          .split('T')[0]

        if (!grouped[dateKey]) grouped[dateKey] = []
        grouped[dateKey].push(media)
      })

      const arrGroupDate = Object.keys(grouped)
      const resGrouped = []

      for (let i = 0; i < arrGroupDate.length; i++) {
        resGrouped.push({
          formattedDate: this.momentDateShortMonth(arrGroupDate[i]),
          media: this.groupingBasedOnDate
            ? []
            : this.getHandleAlertMediaList(grouped[arrGroupDate[i]]),
          mediaGrouped: this.groupingBasedOnDate
            ? this.getHandleAlertMediaGrouped(this.getMediaGrouped(grouped[arrGroupDate[i]]))
            : [],
        })
      }

      return resGrouped
    },
  },

  async mounted() {
    try {
      await this.loadDataMedia()
    } catch (error) {
      this.$mcToast.error(error?.message ?? this.$t('global.somethingWentWrong'))
      console.log(error)
    }
    window.addEventListener('scroll', (e) => {
      this.handleScroll(e)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', (e) => {
      this.handleScroll(e)
    })
  },
  methods: {
    addCollapsed(formattedDate) {
      this.dateCollapsed.push(formattedDate)
    },
    removeCollapsed(formattedDate) {
      this.dateCollapsed.splice(
        this.dateCollapsed.findIndex((a) => a === formattedDate),
        1
      )
    },
    async handleClickMediaItem(media) {
      let address

      if (this.groupingBasedOnDate) {
        address = this.mapAddress[media.vehicleId + '_' + media.startTime]
      } else {
        address = this.mapAddress[media.vehicle.id + '_' + media.startTime]
      }

      this.$store.commit('media/setModalMedia', { ...media, address })

      await this.$nextTick()
      this.$bvModal.show('modal-media')
    },

    async loadDataMedia(page = 1) {
      if (page === 1) {
        this.mapMedia = {}
        this.dateNow = moment().toISOString()
        await this.$nextTick()
        this.mediaList = []
        this.hasReachLimitData = false
      }

      const show = this.paginationState.show

      // condition if reach max show data
      if (this.hasReachLimitData && page > 1) return
      this.loadingLoadData = true

      const filterIdentifier = {
        photo: this.activeFilters.mediaType.all ? true : this.activeFilters.mediaType.photo,
        video: this.activeFilters.mediaType.all ? true : this.activeFilters.mediaType.video,
      }

      const startOfDate = this.formatDateToUtc(this.activeFilters.date + ' 00:00:00'),
        endOfDate = this.formatDateToUtc(this.activeFilters.date + ' 23:59:59')

      const filterVideo = filterIdentifier.video
        ? ['SystemVideo', 'HistoricalVideo', 'RequestVideo']
        : []
      const filterPhoto = filterIdentifier.photo
        ? this.hasScopeNewModalMedia
          ? ['Picture', 'SystemVideo', 'RequestVideo', 'CaptureVideo']
          : ['Picture']
        : []

      const filterModal = {
        identifier: [...filterPhoto, ...filterVideo],
        mediaTime: { start: startOfDate, end: endOfDate },
        vehicleId: this.activeFilters.vehicleId.length ? this.activeFilters.vehicleId : undefined,
      }

      const isToday = moment().format('YYYY-MM-DD') === this.activeFilters.date

      if (isToday) {
        filterModal.mediaTime.end = this.dateNow
        filterModal['downloadOn'] = { end: this.dateNow, start: startOfDate }
      }

      const filter = {
        orderBy: [
          JSON.stringify({ startTime: 'desc' }),
          JSON.stringify({ downloadVideoHistoryId: 'desc' }),
        ],
        pagination: {
          show,
          page,
        },
        allUsers: true,
        status: 'Success',

        // from search
        search: this.search ?? undefined,

        // from filter modal
        ...filterModal,
      }
      const res = await this.$apollo.query({
        query: GET_MEDIA_LIST,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })
      this.paginationState.page =
        res.data.downloadVideoHistories.downloadVideoHistories.pagination.page
      this.paginationState.show =
        res.data.downloadVideoHistories.downloadVideoHistories.pagination.show
      this.paginationState.total =
        res.data.downloadVideoHistories.downloadVideoHistories.pagination.total

      let tempMediaList = []

      if (page === 1) {
        this.tempAlreadyTimeKeyMedia = {}
        this.mediaList = []
      }

      res.data.downloadVideoHistories.downloadVideoHistories.data.forEach((data) => {
        if (this.mapMedia?.[data.downloadId]) return
        if (!data.convertedChannel) return
        const calculatedChannel = DEVICE_CODE_LIST.CONCOX_CAMERA.includes(
          data.vehicle.device.deviceCode
        )
          ? data.channel
          : data.convertedChannel

        const tempData = {
          ...data,
          mediaKey: `${data.identifier === 'P' ? 'image' : 'video'}_${calculatedChannel}`,
          calculatedChannel,
        }

        const isVideoCapture = data.identifier === 'C'

        const shouldCreatePictureFromVideo =
          this.hasScopeNewModalMedia &&
          filterIdentifier.photo &&
          (tempData.identifier === 'V' ||
            tempData.identifier === 'R' ||
            tempData.identifier === 'C')

        if (!shouldCreatePictureFromVideo) {
          tempMediaList.push(tempData)
        } else {
          const mediaPictureFromVideo = {
            ...tempData,
            mediaKey: `image_${tempData.calculatedChannel}`,
            identifier: 'P',
            isPictureFromVideo: true,
          }

          if (filterIdentifier.video && !isVideoCapture) {
            tempMediaList.push(tempData)
          }

          tempMediaList.push(mediaPictureFromVideo)
        }

        this.mapMedia[data.downloadId] = tempData
      })

      if (tempMediaList.length === 0 && page > 1) {
        this.hasReachLimitData = true
        this.loadingLoadData = false
        return
      }

      tempMediaList.sort((a, b) => {
        const startTimeDifference = new Date(b.startTime) - new Date(a.startTime)

        if (startTimeDifference !== 0) return startTimeDifference

        return Number(Boolean(a.isPictureFromVideo)) - Number(Boolean(b.isPictureFromVideo))
      })

      const _mediaList = tempMediaList.filter((media) => {
        const key = `${media.vehicleId}_${media.startTime}_${media.mediaKey}`

        if (this.tempAlreadyTimeKeyMedia[key]) return false

        this.tempAlreadyTimeKeyMedia[key] = true
        return true
      })

      this.mediaList.push(..._mediaList)

      await this.$nextTick()
      this.loadingLoadData = false
      this.doMapForGetAddress(_mediaList)
    },
    handleScroll(e) {
      const scrollHeight = document.documentElement.scrollHeight
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const clientHeight = window.innerHeight || document.documentElement.clientHeight
      if (this.loadingLoadData || scrollTop === this.scrollYPosition) return
      this.scrollYPosition = scrollTop
      // Check if we're near bottom
      if (scrollHeight - scrollTop - clientHeight < 20) {
        this.loadDataMedia(this.paginationState.page + 1)
      }
    },

    getHandleAlertMediaGrouped(mediaGrouped) {
      const res = []
      for (let i = 0; i < mediaGrouped.length; i++) {
        const grouped = mediaGrouped[i]
        const rawAlerts = grouped.rawAlerts
        if (rawAlerts.length === 0 || rawAlerts.length === 1) {
          res.push(grouped)
        } else if (rawAlerts.length > 1) {
          for (let j = 0; j < rawAlerts.length; j++) {
            const _grouped = { ...grouped }
            const alert = rawAlerts[j]
            _grouped.rawAlerts = [alert]
            res.push(_grouped)
          }
        }
      }
      return res
    },

    getHandleAlertMediaList(mediaList) {
      const res = []
      for (let i = 0; i < mediaList.length; i++) {
        const media = mediaList[i]
        const rawAlerts = media.rawAlerts
        if (rawAlerts.length === 0 || rawAlerts.length === 1) {
          res.push(media)
        } else if (rawAlerts.length > 1) {
          for (let j = 0; j < rawAlerts.length; j++) {
            const _media = { ...media }
            const alert = rawAlerts[j]
            _media.rawAlerts = [alert]
            res.push(_media)
          }
        }
      }
      return res
    },

    getMediaGrouped(mediaList) {
      const tempMediaMap = mediaList.reduce((acc, curr) => {
        const vehicleId = curr.vehicle.id
        const startTime = curr.startTime
        const identifier = curr.identifier
        let key
        if (identifier === 'H') {
          key = `${vehicleId}_${startTime}_${identifier}`
        } else {
          key = `${vehicleId}_${startTime}`
        }
        if (!acc?.[key]) {
          acc[key] = [curr]
        } else {
          acc[key].push(curr)
        }
        return acc
      }, {})
      const resGrouped = []
      Object.entries(tempMediaMap).forEach(([key, mediaList]) => {
        const isVideoHistory = key.split('_').length === 3 && key.split('_')[2] === 'H'
        const rawAlerts = []
        for (let i = 0; i < mediaList.length; i++) {
          const media = mediaList[i]
          const _rawAlerts = media.rawAlerts
          for (let j = 0; j < _rawAlerts.length; j++) {
            const alert = _rawAlerts[j]
            if (rawAlerts.some(({ rawAlertId }) => alert.rawAlertId == rawAlertId)) {
              continue
            }
            rawAlerts.push(_rawAlerts[j])
          }
        }
        resGrouped.push({
          startTime: key.split('_')[1],
          mediaList: mediaList.sort((a, b) => a.channel - b.channel),
          rawAlerts,
          vehicleId: Number(key.split('_')[0]),
          type: isVideoHistory
            ? 'videoHistory'
            : rawAlerts.length > 0
            ? 'rawAlerts'
            : 'autoCaptured',
        })
      })

      resGrouped.sort((a, b) => new Date(b.startTime) - new Date(a.startTime))
      return resGrouped
    },
    /**
     * Groups dates that are within a specified threshold of each other
     * @param {string[]} dates Array of ISO date strings
     * @param {number} thresholdMinutes Maximum time difference in minutes to consider dates as part of the same group
     * @returns {Array<string[]>} Array of date groups
     */
    groupDatesByThreshold(dates, thresholdMinutes) {
      // Sort the dates chronologically
      const sortedDates = [...dates].sort()

      // Initialize the result array with the first date in its own group
      const groups = []

      if (sortedDates.length === 0) {
        return groups
      }

      // Start the first group with the first date
      let currentGroup = [sortedDates[0]]
      let prevDate = new Date(sortedDates[0])

      // Process the remaining dates
      for (let i = 1; i < sortedDates.length; i++) {
        const currentDate = new Date(sortedDates[i])

        // Calculate time difference in milliseconds and convert to minutes
        const diffInMinutes = (currentDate - prevDate) / (1000 * 60)

        if (diffInMinutes <= thresholdMinutes) {
          // Current date is within threshold of previous date, add to current group
          currentGroup.push(sortedDates[i])
        } else {
          // Current date exceeds threshold, finish current group and start a new one
          groups.push(currentGroup)
          currentGroup = [sortedDates[i]]
        }

        prevDate = currentDate
      }

      // Add the last group if it's not empty
      if (currentGroup.length > 0) {
        groups.push(currentGroup)
      }

      return groups
    },

    doMapForGetAddress(newMediaList) {
      // collect dateTimeGrouping
      const dateTimeGrouped = []
      newMediaList.forEach((media) => {
        if (
          dateTimeGrouped.some(
            ({ mediaDate, vehicleId }) =>
              media.vehicle.id === vehicleId && mediaDate === media.startTime
          )
        )
          return
        dateTimeGrouped.push({ mediaDate: media.startTime, vehicleId: media.vehicle.id })
        this.$set(this.mapAddress, media.vehicle.id + '_' + media.startTime, null)
      })
      dateTimeGrouped.reverse()

      const mapVehicleIdMediaDateList = dateTimeGrouped.reduce((acc, { vehicleId, mediaDate }) => {
        const { isMediaDateExistInLocalStorage, isExpired, mediaAddressFromLocalStorage } =
          this.getMapAddressFromLocalStorage(vehicleId + '_' + mediaDate)

        if (isMediaDateExistInLocalStorage && !isExpired) {
          this.$set(
            this.mapAddress,
            vehicleId + '_' + mediaDate,
            mediaAddressFromLocalStorage.address
          )
          return acc
        }

        if (!acc[vehicleId]) {
          acc[vehicleId] = [mediaDate]
        } else {
          acc[vehicleId] = [...acc[vehicleId], mediaDate]
        }
        return acc
      }, {})

      const vehicleIdStartEndTimeClosest = []
      Object.keys(mapVehicleIdMediaDateList).forEach((vehicleId) => {
        const groupedByClosestDateTime = this.groupDatesByThreshold(
          mapVehicleIdMediaDateList[vehicleId],
          2
        )
        let res = []
        groupedByClosestDateTime.forEach((dateArr) => {
          let startTime, endTime
          if (dateArr.length === 1) {
            const _date = moment(dateArr[0])
            startTime = _date.clone().subtract(60, 'seconds').toISOString()
            endTime = _date.clone().add(60, 'seconds').toISOString()
          } else {
            const _dateFirst = moment(dateArr[0])
            const _dateLast = moment(dateArr[dateArr.length - 1])
            startTime = _dateFirst.clone().subtract(60, 'seconds').toISOString()
            endTime = _dateLast.clone().add(60, 'seconds').toISOString()
          }
          res.push({ startTime, endTime })
        })
        vehicleIdStartEndTimeClosest.push({ vehicleId: Number(vehicleId), startEndClosest: res })
      })

      const promisesRawLocations = []

      vehicleIdStartEndTimeClosest.forEach(({ vehicleId, startEndClosest }) => {
        startEndClosest.forEach(({ startTime, endTime }) => {
          promisesRawLocations.push(this.getRawLocations(vehicleId, startTime, endTime))
        })
      })
      Promise.all(promisesRawLocations).then((resPromise) => {
        resPromise.forEach((locations) => {
          const _locations = locations ?? []
          this.allLocations.push(
            ..._locations.map(({ vehicleId, sentOn, latitude, longitude }) => ({
              vehicleId,
              sentOn,
              latitude,
              longitude,
            }))
          )
        })

        // Chek if there is mediaGrouped tha have alert
        // If have, get address from alert lat long
        this.doMapForAlertDate(newMediaList, dateTimeGrouped)
        Promise.all([
          this.doMapForAddressFromRawLocations(),
          this.doMapForAddressFromRawAlerts(),
        ]).then((res) => {
          // Set empty map to '-'

          Object.keys(this.mapAddress).forEach((key) => {
            if (!this.mapAddress[key]) {
              this.$set(this.mapAddress, key, '-')
            }
          })
        })
      })
    },

    // this function to get lat long in alert grouped by media date
    doMapForAlertDate(newMediaList, dateTimeGrouped) {
      const rawAlertsMediaDate = []
      dateTimeGrouped.forEach(({ mediaDate, vehicleId }) => {
        newMediaList.forEach((m) => {
          if (m.vehicle.id === vehicleId && m.startTime === mediaDate && m.rawAlerts.length) {
            m.rawAlerts.forEach((alert) => {
              if (
                !rawAlertsMediaDate.some(
                  (r) => r.vehicleId === alert.vehicleId && r.mediaDate === alert.mediaDate
                )
              ) {
                rawAlertsMediaDate.push({
                  vehicleId: m.vehicle.id,
                  mediaDate: m.startTime,
                  latitude: alert.latitude,
                  longitude: alert.longitude,
                })
              }
            })
          }
        })
      })
      this.rawAlertsMediaDate = rawAlertsMediaDate
    },

    async doMapForAddressFromRawAlerts() {
      return new Promise((resolve) => {
        const rawAlertsMediaDate = this.rawAlertsMediaDate
        if (rawAlertsMediaDate.length === 0) {
          resolve(true)
          return
        }
        const promises = []
        const tempKey = []
        rawAlertsMediaDate.forEach(({ vehicleId, mediaDate, latitude, longitude }) => {
          promises.push(GetAddressData(latitude, longitude))
          const key = vehicleId + '_' + mediaDate
          tempKey.push(key)
        })
        Promise.all(promises).then((res) => {
          res.forEach((response, index) => {
            const formattedAddress = response.display_name
            const key = tempKey[index]

            this.setAddressData(key, formattedAddress)
            resolve(true)
          })
        })
      })
    },

    async doMapForAddressFromRawLocations() {
      return new Promise((resolve) => {
        const allLocations = this.allLocations
        const promises = []
        const tempKey = []
        Object.keys(this.mapAddress).forEach((key) => {
          const [vehicleId, mediaDate] = key.split('_')
          const closestBeforeMediaDate = this.findClosestDateBeforeMoment(
            allLocations
              .filter((loc) => loc.vehicleId === Number(vehicleId))
              .map(({ sentOn }) => sentOn),
            mediaDate
          )
          let address
          const { isMediaDateExistInLocalStorage, isExpired } = this.getMapAddressFromLocalStorage(
            vehicleId + '_' + mediaDate
          )

          if (isMediaDateExistInLocalStorage && !isExpired) {
            return
          }

          if (closestBeforeMediaDate) {
            tempKey.push(key)
            promises.push(
              GetAddressData(
                allLocations.find(({ sentOn }) => closestBeforeMediaDate === sentOn).latitude,
                allLocations.find(({ sentOn }) => closestBeforeMediaDate === sentOn).longitude
              )
            )
          }
          this.$set(this.mapAddress, key, address)
        })

        if (promises.length === 0) {
          resolve(true)
          return
        }

        Promise.all(promises).then((res) => {
          res.forEach((r, i) => {
            const formattedAddress = r.display_name
            const key = tempKey[i]

            this.setAddressData(key, formattedAddress)
            resolve(true)
          })
        })
      })
    },

    /**
     *
     * @param key format `${vehicleId}_${mediaDate}`
     * @param formattedAddress
     */
    setAddressData(key, formattedAddress) {
      // set to local storage with expired is 1 day
      const now = Date.now()
      const ONE_DAY_MS = 24 * 60 * 60 * 1000
      const expirationTimestamp = now + ONE_DAY_MS

      const mediaLocalStorage =
        JSON.parse(localStorage.getItem(this.keyMediaAddressLocalStorage)) ?? {}
      mediaLocalStorage[key] = {
        address: formattedAddress,
        expirationTimestamp,
      }

      localStorage.setItem(this.keyMediaAddressLocalStorage, JSON.stringify(mediaLocalStorage))

      this.$set(this.mapAddress, key, formattedAddress)
    },

    /**
     *
     * @param key format `${vehicleId}_${mediaDate}`
     */
    getMapAddressFromLocalStorage(key) {
      const mediaAddressFromLocalStorage =
        JSON.parse(localStorage.getItem(this.keyMediaAddressLocalStorage))?.[key] ?? null
      const isMediaDateExistInLocalStorage = !!mediaAddressFromLocalStorage
      let isExpired = false
      if (isMediaDateExistInLocalStorage) {
        const expiredTimestamp = mediaAddressFromLocalStorage.expirationTimestamp
        if (Date.now() > expiredTimestamp) {
          isExpired = true
        }
      }

      return {
        isMediaDateExistInLocalStorage,
        isExpired,
        mediaAddressFromLocalStorage,
      }
    },
    async getRawLocations(vehicleId, startTime, endTime) {
      const response = await this.$apollo.query({
        query: GET_RAW_LOCATION,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            vehicleId: vehicleId,
            startDate: startTime,
            endDate: endTime,
          },
        },
      })
      return response.data.rawLocations.rawLocations
    },
    /**
     * Finds the closest date that comes before the target date using Moment.js
     * @param {string[]} dates Array of ISO date strings
     * @param {string} targetDate Target date as ISO string
     * @returns {string} The closest date before the target date, or '_' if no earlier date exists or array is empty
     */
    findClosestDateBeforeMoment(dates, targetDate) {
      // Check if the array is empty
      if (!dates || dates.length === 0) {
        return null
      }

      // Create moment object for target date
      const targetMoment = moment(targetDate)

      // Filter dates that are earlier than the target date
      const earlierDates = dates.filter((dateStr) => {
        return moment(dateStr).isBefore(targetMoment)
      })

      if (earlierDates.length === 0) {
        return null // No dates are earlier than the target
      }

      // Sort the dates in descending order (newest first)
      // This gives us the closest date before the target at index 0
      return earlierDates.sort((a, b) => {
        return moment(b).valueOf() - moment(a).valueOf()
      })[0]
    },
  },
}
</script>
